export default {
  headerColor: '#003870',
  headerHeight: '63px'
}